module.exports = __webpack_public_path__ + "static/claimer-logo-b1b6277a38071ce24812856b408edf36.png";